import { z } from 'zod';

import { LISTINGS_TABLE_SALE_TYPES } from './dynamoDb.const';

export const ListingsTableSaleTypes = z.nativeEnum(LISTINGS_TABLE_SALE_TYPES);

export const GetAdditionalVehicleDetailsSchema = z
	.object({
		saleType: ListingsTableSaleTypes.optional(),
	})
	.optional();

export const AdditionalVehicleDetailsSchema = z
	.record(
		z
			.record(
				z
					.object({
						expiryDate: z.string().optional(),
						originalPrice: z.number().optional(),
						reheatCount: z.number().optional(),
					})
					.default({}),
			)
			.default({}),
	)
	.default({});

export const ListingsTableItemSchema = z.object({
	data: z
		.object({
			expiryTimeUTC: z.string().optional(),
			originalPrice: z.number().optional(),
			reheatCount: z.number().optional(),
		})
		.optional(),
	PK: z.string(),
	SK: z.string(),
});

export const ListingsTableItemsSchema = z.array(ListingsTableItemSchema);

export type ListingsTableItem = z.infer<typeof ListingsTableItemSchema>;
